<template>
    <!-- <div class="outlet-banner" :style="{ 'background-image': 'url(/images/SHOP-BY-ROOM.jpg)' }">
        <div class="bg-section">
            <div class="bg-text">Terms & Conditions</div>
        </div>
    </div> -->
    <div class="contact-us-parent-conatiner">
        <div class="contact-us-page-container">
            <div class="contact-page-left-side-section">
                <div class="contact-us-heading">Contact Us</div>

                <hr class="hr-line" />
                <form method="POST" class="register-form" id="register-form" @submit.prevent="sendEmail">
                    <div class="personal-info-section">
                        <div class="personal-info-heading-text">
                            Personal Information
                        </div>

                        <div class="personal-info-box-section">
                            <div class="form-group contact-us-form">
                                <i class="fa fa-user"></i>
                                <input class="personal-info-name-text form-group-input" type="text" name="client_name"
                                    id="name" placeholder="Your Name" v-model="fullName" />
                                <pre style="color: #F69320">{{
                                    errorMessage.fullName
                                }}</pre>
                            </div>
                            <div class="form-group contact-us-form">
                                <i class="fa fa-envelope"></i>
                                <input class="personal-info-email-text form-group-input" type="email" name="client_email"
                                    id="email" placeholder="Enter e-mail" v-model="email" />

                                <pre style="color: #F69320">{{
                                    errorMessage.email
                                }}</pre>
                            </div>

                            <div class="form-group contact-us-form">
                                <div class="perosnal-info-mobile-section contact-info-mobile-section">
                                    <div class="personal-info-mobile-flag">
                                        <img :src="currenciesStore.country.img" alt="flag-icon" />
                                    </div>

                                    <div class="personal-mobile-country-code">
                                        {{ currenciesStore.country.numCode }}
                                    </div>
                                </div>
                                <input class="contact-info-mobile-text form-group-input" type="type" name="client_mobile"
                                    id="mobile" placeholder="Enter Contact No" v-model="mobile" />
                                <pre style="color: #F69320">{{
                                    errorMessage.mobile
                                }}</pre>
                            </div>
                        </div>
                    </div>

                    <div class="form-group contact-us-form">
                        <input class="personal-info-subject-text form-group-input" type="type" name="client_subject"
                            id="subject" placeholder="Subject" v-model="subject" />
                        <pre style="color: #F69320">{{ errorMessage.mobile }}</pre>
                    </div>

                    <hr class="hr-line" />

                    <div class="form-group contact-us-form message-box-container">
                        <i class="fa fa-comment-o message-icon"></i>
                        <textarea placeholder="Message" name="client_message" v-model="description" id="" cols="29"
                            rows="10" style="
                                border: none;
                                padding: 1% 5%;
                                border: 1px solid #e6e6e6;
                            ">
                        </textarea>
                    </div>

                    <hr class="hr-line" />

                    <div class="submit-btn-box-container">
                        <button id="signup" class="sumbit-button-box-section form-submit">
                            Send Your Message
                            <i class="fa fa-paper-plane" style="margin-left: 15px"></i>
                        </button>
                    </div>
                </form>
            </div>

            <div class="contact-page-right-side-section">
                <div class="outlet-text-section">
                    <div class="outlet-icon">
                        <i class="fa fa-phone"></i>
                    </div>
                    <div class="text-details">
                        <div class="big-text-details">Phone</div>
                        <div class="small-text-details">
                            <a href="tel:+8809611116770" class="headphone-span">+88 09611116770</a>
                            <br />
                            <a href="tel:+8801847004700" class="headphone-span">+88 01847004700</a>
                        </div>
                    </div>
                </div>

                <div class="outlet-text-section">
                    <div class="outlet-icon">
                        <i class="fa fa-home address"> </i>
                    </div>
                    <div class="text-details">
                        <div class="big-text-details">Address</div>
                        <div class="small-text-details">
                            66 Pragoti Sarani Baridhara, Block-J, Dhaka, Bangladesh
                        </div>
                    </div>
                </div>

                <div class="outlet-text-section">
                    <div class="outlet-icon">
                        <i class="fa fa-envelope"></i>
                    </div>
                    <div class="text-details">
                        <div class="big-text-details">Email</div>
                        <div class="small-text-details">
                            crm@akhtar.com.bd
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
// import { Notyf } from 'notyf';
// import 'notyf/// notyf.min.css';
import emailjs from "@emailjs/browser";
import { useCurrenciesStore } from "@/stores/currencies-store";
//schema part
import { useStaticSchema } from '@/libs/utils/seo-helper'

useHead({
  title: 'Contact Us - Akhter Furnishers',
  meta: [
    { name: 'description', content: 'Need help or have a question? Contact Akhter Furnishers via phone, email, or our online form.' }
  ]
})

useStaticSchema('contact')
const currenciesStore = useCurrenciesStore();

// const notyf = new Notyf();
const center = ref({ lat: 23.765628910945264, lng: 90.36083590658902 });

const fullName = ref("");
const email = ref("");
const subject = ref("");
const description = ref("");
const mobile = ref("");
const password = ref("");
const confirmPassword = ref("");
const showSpinner = ref(false);
const isValidate = ref(false);
const isChecked = ref(false);

const errorMessage = ref({
    fullName: "",
    email: "",
    mobile: "",
    subject: "",
    description: "",
});

const clearData = async () => {
    fullName.value = "";
    email.value = "";
    mobile.value = "";
    subject.value = "";
    description.value = "";
};

const clearValidations = async () => {
    Object.keys(errorMessage.value).forEach((key) => {
        errorMessage.value[key] = "";
    });
};

const validate = async () => {
    clearValidations();
    if (fullName.value.trim().length == 0) {
        errorMessage.value.fullName = "Please Give Your First Name";
        return false;
    }
    if (email.value.trim().length == 0) {
        errorMessage.value.email = "Please Give Your Email";
        return false;
    }

    if (!email.value.match(/\S+@\S+\.\S+/)) {
        errorMessage.value.email = "Please Give a Correct Email";
        return false;
    }
    if (subject.value.trim().length == 0) {
        errorMessage.value.subject = "Please Tell Us your Query";
        return false;
    }
    if (description.value.trim().length == 0) {
        errorMessage.value.description = "Please Give Us a Message";
        return false;
    }
    return (isValidate.value = true);
};

const sendEmail = (e) => {
    if (fullName.value && fullName.value.length > 0) {
        emailjs
            .sendForm(
                "service_k3p8kyc",
                "template_hb9t21e",
                e.target,
                "WGillGnN5GEGoPwRu"
            )
            .then(
                (result) => {
                    console.log("SUCCESS!", result.text);
                    // notyf.success("Mail Sent Successfully");
                },
                (error) => {
                    console.log("FAILED...", error.text);
                    // notyf.error("Mail Failed to Sent");
                }
            );
        clearData();
    }
};
</script>

<style>
.contact-us-parent-conatiner {
    background-color: #f5f5f5;
}

.contact-us-page-container {
    padding: 55px 10%;

    display: flex;
    column-gap: 30px;
    justify-content: center;
}

.contact-us-form {
    position: relative;
}

.contact-us-form i {
    position: absolute;
    top: 25%;
    z-index: 999;
    left: 5%;
}

.form-group-input {
    width: 300px;
    height: auto;
    border: 1px solid #e6e6e6;
    padding: 10px 15%;
    padding-right: 5%;
    border-radius: 5px;
}

.personal-info-subject-text {
    padding: 10px !important;
}

.message-icon {
    top: 17% !important;
    left: 3% !important;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .contact-us-page-container {
        padding: 55px 0%;

        display: flex;
        flex-direction: column;
    }
}

.contact-page-left-side-section {
    display: flex;
    flex-direction: column;
    padding: 15px;
    row-gap: 20px;

    width: 100%;

    background-color: #fff;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .contact-page-left-side-section {
        display: flex;
        flex-direction: column;
        row-gap: 0px;

        background-color: #fff;
    }
}

.contact-us-heading {
    font-size: 20px;
    font-weight: 500;
}

.hr-line {
    border: 1px solid #6e6767;
}

.personal-info-section {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
}

.personal-info-heading-text {
    font-size: 16px;
    color: #212529;
}

.personal-info-box-section {
    display: flex;
    column-gap: 50px;
    margin-bottom: 20px;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .personal-info-box-section {
        display: flex;
        flex-direction: column;

        row-gap: 20px;
    }
}

.perosnal-info-name-section {
    display: flex;
    column-gap: 10px;
}

.gap {
    padding: 10px;

    box-sizing: border-box;
    width: 300px;
    height: 45px;
    border-radius: 5px;
    background-color: #f5f5f5;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .gap {
        width: 95%;
    }
}

.perosnal-info-email-section {
    display: flex;
    column-gap: 10px;
}

.perosnal-info-mobile-section {
    display: flex;
    column-gap: 10px;
}

.contact-info-mobile-section {
    position: absolute;
    top: 17%;
    z-index: 99;
    left: 5%;
}

.personal-info-mobile-flag {
    width: 25px;
    margin-right: 5px;
}

.personal-info-mobile-flag img {
    height: 20px;
}

.contact-info-mobile-text {
    padding-left: 30% !important;
}

.dropdown-section {
    display: flex;
    column-gap: 120px;
    justify-content: space-between;

    background-color: #f5f5f5e2;

    padding: 10px;
    width: 30%;

    border-radius: 5px;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .dropdown-section {
        width: 95%;
    }
}

.message-box-container {
    display: flex;
    column-gap: 20px;

    padding: 10px;
    width: 50%;

    border-radius: 5px;

    height: 120px;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .message-box-container {
        width: 95% !important;
    }
}

.message-box-section {
    display: flex;
    column-gap: 10px;
}

.submit-btn-box-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
}

.sumbit-button-box-section {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #F69320;
    box-sizing: border-box;
    border: 1px solid #F69320;
    width: auto;
    height: 40px;
    border-radius: 5px;

    padding: 15px;
    color: #fff;
    font-weight: 500;
}

.sumbit-button-box-section:hover {
    background-color: #fff;
    border: 1px solid #F69320;
    color: #F69320;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .submit-btn-box-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .sumbit-button-box-section {
        padding-left: 0%;
        margin-left: 0px;
    }
}

.sumbit-button-text {
    color: #fff;
}

.contact-page-right-side-section {
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    background-color: #f6f6f6;
    padding: 10px;
}

.outlet-text-section {
    display: flex;
    column-gap: 15px;
}

.outlet-icon {
    width: 5%;
    display: flex;
    justify-content: center;
}

.text-details {
    width: 95%;
}

.big-text-details {
    font-size: 14px;
    font-weight: 700;
}

.small-text-details {
    font-size: 13px;
}

.company-info {
    display: flex;
    column-gap: 20px;
}

.demo-text {
    font-size: 12px;
    color: grey;

    margin-bottom: 10px;
}
</style>
